/*
@file-overview 

- This service creates a global instance of the users session object for components and services to use

- This service must be populated with an object that resembles the response from the AEM /userinfo servlet
  - NOTE : The Interface IUserSession strictly contains only the possible response fields from the AEM /userinfo servlet

*/
import { Injectable } from '@angular/core';
import { IUserSession } from '../models/user-session.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class UserInfoService {
  private _userSession : IUserSession;

  public cartModified = new Subject<any>();
  public $cartModified = this.cartModified.asObservable();

  constructor() {
    window[ 'userInfoServiceRefAL' ] = {
      service: this
    };
  }

  public setUserSession(userSession : IUserSession) {
    // console.log("UserInfoService : setUserSession");
    // console.log(userSession);

    this._userSession = {...userSession};
  }

  public initUserSession(){
    const {branchId, preferenceMode, j4u, zipcode, clubCard} = window['AB']['userInfo'];
    const userInfo = {...window['AB']['userInfo'], shopStoreId:branchId,shopZipcode:zipcode, preference: preferenceMode, clubCardNumber:clubCard, j4uStoreId:j4u.storeId, j4uZipcode:j4u.zipcode}
    this.setUserSession(userInfo);
  }

  public getUserSession() {
    return this._userSession;
  }

  public getSWY_SHOP_TOKEN() {
    return this._userSession['SWY_SHOP_TOKEN'];
  } 

  public setSWY_SHOP_TOKEN(SWY_SHOP_TOKEN) {
    this._userSession['SWY_SHOP_TOKEN'] = SWY_SHOP_TOKEN;
  } 

  public getUUID() {
    return this._userSession['UUID'];
  } 

  public getBanner() {
    return this._userSession['banner'];
  } 

  public getClubCardNumber() {
    return this._userSession['clubCardNumber'];
  } 

  public getCustomerId() {
    return this._userSession['customerId'];
  }
  
  public getSiteType() {
    return this._userSession['siteType'];
  } 

  public getDisplayableBanner() {
    return this._userSession['displayableBanner'];
  } 

  public getEmail() {
    return this._userSession['email'];
  } 

  public getExpireTime() {
    return this._userSession['expireTime'];
  } 

  public getFirstName() {
    return this._userSession['firstName'];
  } 

  public getJ4uStoreId() {
    return this._userSession['j4uStoreId'];
  } 

  public getJ4uZipcode() {
    return this._userSession['j4uZipcode'];
  } 

  public getPreference() {
    return this._userSession?.['preference'];
  } 

  public getShopStoreId() {
    return this._userSession['shopStoreId'];
  }
  
  public getStoreId() {
    return this._userSession['storeId'];
  }

  public getShopZipcode() {
    return this._userSession['shopZipcode'];
  } 

  public getUserType() {
    return this._userSession['userType'];
  } 

  public getWfcStoreId() {
    return this._userSession['wfcStoreId'];
  }

  public getHouseId() {
    return this._userSession['houseId'];
  }
  
  public getUnattendedDeliveryIsEnabled() {
    return this._userSession['unattendedDeliveryIsEnabled'];
  } 

  public getCustomerType() {
    return this._userSession?.customerType;
  } 
  
  /**
   * Method for checking if user has authenticated userType : 'R' or 'C'
   *
   *  - user will have userType 'C' if they signed in with credentials within the past 45 minutes
   *  - user will have userType 'R' if they have signed in, but have not used their credentials within the past 45 minutes
  */
  public isAuthorized() {
    const userType = this.getUserType().toUpperCase();
    const isAuthorized = userType === 'R' || userType === 'C' ? true : false;
    
    return isAuthorized;
  }
  

  /**
   * Method for getting the user channel based on the session preference
   *
   *  - Each of the  3 preferences maps to a channel :
   *    - Preference : 'delivery':
          Channel  : 'delivery';

        - Preference : 'dug':
          Channel  : 'pickup';

        - Preference : 'j4u':
          Channel  : 'instore';
  */
  public getUserChannel = function() {
    let userPreference = this.getPreference();
    userPreference = userPreference ? userPreference.toLowerCase() : undefined;

    switch (userPreference) {
        case 'delivery':
            return 'delivery';

        case 'dug':
            return 'pickup';

        case 'j4u':
            return 'instore';
        default:
            return '';
    }
  }
}
